/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Models_Auto_Only_DescriptionInputs */



/**
* | output |
* | --- |
* | "Members can only use Auto; individual models are hidden from the chat model picker." |
*
* @param {Org_Models_Auto_Only_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_models_auto_only_description = /** @type {((inputs?: Org_Models_Auto_Only_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Models_Auto_Only_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglieder können ausschließlich Auto verwenden; einzelne Modelle werden in der Chat-Modellauswahl ausgeblendet.")
	return /** @type {LocalizedString} */ ("Members can only use Auto; individual models are hidden from the chat model picker.")
});